import React, { useState } from 'react';

import { useModifiers } from 'lib/hooks/queries/admin/useModifiers';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

import { DEFAULT_COLUMNS } from './configs/defaultColumns';
import { DEFAULT_FILTERS } from './configs/defaultFilters';
import ButtonActions from './lib/ButtonActions';
import ModifierModal from './lib/ModifierModal';

const ModifiersTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedModifierData, setSelectedModifierData] = useState(null);

  const openModal = (item) => {
    setIsModalOpen(true);
    setSelectedModifierData(item);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedModifierData(null);
  };

  const onRowClicked = (event) => {
    if (!event?.event?.target?.closest('.ag-selection-checkbox')) {
      const { error } = event?.data || {};
      if (error) {
        setSelectedModifierData(event?.data);
        openModal();
        return;
      }
    }
    setIsModalOpen(true);
    setSelectedModifierData(event);
  };
  return (
    <>
      <AgTablePage
        onSelectRow={onRowClicked}
        ModalComponent={ModifierModal}
        defaultColumns={DEFAULT_COLUMNS}
        defaultFilters={DEFAULT_FILTERS}
        useData={useModifiers}
        name="modifiers"
        actions={ButtonActions}
        keepOldFilters
      />
      <ModifierModal
        handleClose={closeModal}
        isOpen={isModalOpen}
        modifierData={selectedModifierData}
        modalType="edit"
      />
    </>
  );
};

export default withErrorBoundary(ModifiersTable);
